var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dropdown-menu-container"},[(_vm.space)?_c('div',{staticClass:"top-space",style:({ height: `${_vm.space}px` })}):_vm._e(),_c(_vm.as,{tag:"component",staticClass:"dropdown-menu-container",style:({ top: `calc(100% + ${_vm.space}px )`, zIndex: _vm.zIndex })},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }